import classNames from 'classnames';

export interface PageNavigationProps {
  className?: string;
  size?: 'default' | 'none';
}

export function PageNavigation({
  children,
  className,
  size = 'default',
}: React.PropsWithChildren<PageNavigationProps>) {
  return (
    <nav className={classNames(className, 'bg-background text-gray-400 ')}>
      <div className={classNames('mx-auto')}>{children}</div>
    </nav>
  );
}

export default PageNavigation;
